import React from 'react'

export default function Verifone() {
  return (
    <>
    
   
    </>
  )
}
